import React, { memo } from "react";
import styles from "./CardOption.module.scss";
import { MastercardLogo, VisaLogo } from "../../../../assets/icons";
import { CustomerPaystackCard } from "../../../../model/customer/customer";

type Props = {
	card: CustomerPaystackCard;
	selected: boolean;
	onSelect: (card: CustomerPaystackCard) => void;
};

const CardOption: React.FC<Props> = memo((props: Props) => {
	const { card, selected, onSelect } = props;

	const getCardTypeClassNames = () => {
		let result = styles.card;

		switch (card.brand) {
			case "visa":
				result += ` ${styles.visaCard}`;
				break;
			case "mastercard":
				result += ` ${styles.masterCard}`;
				break;
			default:
				result += ` ${styles.visaCard}`;
		}

		return result;
	};

	const getExpirationDate = () => {
		if (!card.expMonth || !card.expYear) {
			return "";
		}

		return `${card.expMonth}/${card.expYear?.slice(-2)}`;
	};

	const selectCard = () => {
        if (card.status === "Pending") {
            return;
        }
		onSelect(card);
	};

	return (
		<button className={styles.cardRadioContainer} onClick={selectCard}>
			<input type="radio" name="card" checked={selected} onSelect={selectCard} />
			<div className={styles.cardContainer}>
				<div className={getCardTypeClassNames()}>
					<div className={styles.cardHeader}>
						<div className={styles.cardHeaderIcon}>
							{(() => {
								switch (card.brand) {
									case "visa":
										return <VisaLogo />;
									case "mastercard":
										return <MastercardLogo />;
									default:
										return <VisaLogo />;
								}
							})()}
						</div>
					</div>
					<div className={styles.cardBody}>
						<div className={styles.cardBodyContent}>
							<div className={styles.cardAccountName}>{card.accountName}</div>
							<div className={styles.cardExpirationDate}>{getExpirationDate()}</div>
						</div>
						<div className={styles.cardNumbers}>**** **** **** {card.last4}</div>
					</div>
				</div>
			</div>
			{card.status === "Pending" && <div className={styles.pendingText}>Pending Validation</div>}
		</button>
	);
});

export default CardOption;
